import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import styled from '@emotion/styled'
import { EmailVerification } from '@yuno/design-system-web'
import { LoginLoading } from './login-loading'
import { TEXTS } from '../common/utils/constants'

const Wrapper = styled.div({
  background: '#FCFCFF',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
})

const AuthButton = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0()
  const urlParams = new URLSearchParams(window.location.search)
  const error = urlParams.get('emailError')
  const user = urlParams.get('user')
  const handleClick = () => {
    window.location.href = window.location.origin
  }

  useEffect(() => {
    async function validateLogin() {
      if (!isAuthenticated && !error) {
        loginWithRedirect()
      }
    }
    validateLogin()
  }, [isAuthenticated, loginWithRedirect])

  if (error) {
    return (
      <EmailVerification
        handleClick={handleClick}
        iconName={'Envelope'}
        title={TEXTS.TITLE_VERIFY_EMAIL}
        subTitle={TEXTS.SUBTITLE_VERIFY_EMAIL(user)}
        buttonText={TEXTS.BACK_TO_LOGIN}
      />
    )
  }

  return (
    <Wrapper>
      <LoginLoading />
    </Wrapper>
  )
}

export default AuthButton
